import * as types from "../../mutation-types.js";
import http from "@service/http";
import { restCall } from "@service/adapter";
import util from "@common/utils/util";
import Constant from "@/Constant";
import { storage } from "@common/utils/util.js";

/**
 * 登陆-注册STORE
 */
export default {
  state: {
    isLogined: false, //判断是否登录
    // userInfo:null,
  },
  actions: {
    //获取验证码
    sendAuthCodeSms({ commit }, params) {
      return http
        .post({
          fn: "mallmem.memLoginHandler.sendAuthCodeSms",
          param: params,
        })
        .then((result) => {
          if (
            result &&
            result.success &&
            result.target &&
            result.target.success
          ) {
            return Promise.resolve(result.target);
          } else {
            return Promise.reject(
              (result && (result.message || result.target.message)) ||
                "获取数据失败"
            );
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    //获取验证码
    checkSmsCode({ commit }, phoneNum) {
      return http
        .post({
          fn: "mallmem.memLoginHandler.checkSmsCode",
          param: phoneNum,
        })
        .then((result) => {
          if (
            result &&
            result.success &&
            result.target &&
            result.target.success
          ) {
            return Promise.resolve(result.target);
          } else {
            return Promise.reject(
              (result && (result.message || result.target.message)) ||
                "获取数据失败"
            );
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    //登录
    quickLogin({ commit }, data) {
      return http
        .post({
          fn: "mallmem.memLoginHandler.quickLogin",
          param: data,
        })
        .then((result) => {
          if (
            result &&
            result.success &&
            result.target &&
            result.target.success
          ) {
            return Promise.resolve(result.target.target);
          } else {
            return Promise.reject(
              (result && (result.message || result.target.message)) ||
                "获取数据失败"
            );
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    //登录
    quickLoginWithCode({ commit }, data) {
      return http
        .post({
          fn: "mallmem.memLoginHandler.quickLoginWithCode",
          param: data,
        })
        .then((result) => {
          if (
            result &&
            result.success &&
            result.target &&
            result.target.success
          ) {
            return Promise.resolve(result.target.target);
          } else {
            return Promise.reject(
              (result && (result.message || result.target.message)) ||
                "获取数据失败"
            );
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    //执行登录
    doLogin({ commit }, { openId, clientType, authToken }) {
      return restCall(Constant.loginReqUrl, {
        p0: openId,
        p1: clientType,
        p2: authToken,
      })
        .then((result) => {
          if (
            result &&
            result.success &&
            result.target &&
            result.target.success
          ) {
            commit(types.USER_INFO, result.target.target);
            return Promise.resolve(result.target.target);
          } else {
            return Promise.reject(
              (result && (result.message || result.target.message)) ||
                "获取数据失败"
            );
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    //13.11.用户登录后，修改购物车数据
    updateMemCartForUserLogin({ commit }) {
      return http
        .post({
          fn: "mallsale.cartHandler.updateMemCartForUserLogin",
          param: [],
        })
        .then((result) => {
          if (
            result &&
            result.success &&
            result.target &&
            result.target.success
          ) {
            return Promise.resolve(result.target.target);
          } else {
            return Promise.reject(
              (result && (result.message || result.target.message)) ||
                "获取数据失败"
            );
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    //退出登录
    logout({ commit }) {
      return http
        .post({
          fn: "mallmem.memLoginHandler.logout",
          param: [],
        })
        .then((result) => {
          if (result && result.success) {
            commit(types.IS_LOGINDE, false);
            commit(types.USER_INFO, "");
            return Promise.resolve(result);
          } else {
            return Promise.reject(
              (result && (result.message || result.target.message)) ||
                "获取数据失败"
            );
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    //执行退出登录
    doLogout({ commit }) {
      return restCall(Constant.logoutBaseUrl, {
        // p0:openId,
        // p1:clientType,
        // p2:authToken
      })
        .then((result) => {
          if (
            result &&
            result.success &&
            result.target &&
            result.target.success
          ) {
            return Promise.resolve(result);
          } else {
            return Promise.reject(
              (result && (result.message || result.target.message)) ||
                "获取数据失败"
            );
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    //5.2.生成微信网页授URL-用户同意授权获取code
    connectOauth2Authorize({ commit }, data) {
      return http
        .post({
          fn: "mallmem.memLoginHandler.connectOauth2Authorize",
          param: data,
        })
        .then((result) => {
          console.log(result);
          if (result && result.success) {
            return Promise.resolve(result);
          } else {
            return Promise.reject(
              (result && (result.message || result.target.message)) ||
                "获取数据失败"
            );
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    //2、调用后台执行微信登录
    doWxMpLogin({ commit }, data) {
      return http
        .post({
          fn: "mallmem.memLoginHandler.doWxMpLogin",
          param: data,
        })
        .then((result) => {
          if (result && result.success) {
            return Promise.resolve(result);
          } else {
            return Promise.reject(
              (result && (result.message || result.target.message)) ||
                "获取数据失败"
            );
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    //登录
    memLogin({ commit }, memLoginInfo) {
      return http
        .post({
          fn: "mallmem.memLoginHandler.login",
          param: memLoginInfo,
        })
        .then((result) => {
          if (
            result &&
            result.success &&
            result.target &&
            result.target.success
          ) {
            return Promise.resolve(result.target.target);
          } else {
            return Promise.reject(
              (result &&
                (result.message || (result.target && result.target.message))) ||
                "获取数据失败"
            );
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    //保存登录信息
    saveWxLogin({ commit }, isLogined) {
      commit(types.IS_LOGINDE, isLogined);
    },
    //保存用户信息
    saveUserInfo({ commit }, userInfo) {
      commit(types.USER_INFO, userInfo);
    },
  },
  mutations: {
    [types.IS_LOGINDE](state, isLogined) {
      state.isLogined = isLogined;
      storage.local.set("isLogined", isLogined);
    },
  },
  getters: {
    isLogined: (state) => {
      if (!state.isLogined) {
        return storage.local.get("isLogined");
      }
      return state.isLogined;
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/login/index.js